import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Box as InfoTitle, Box as Section, Tooltip } from '@node-space/ui-components'
import { ModulrCountriesType } from '../types'

export interface ModulrAgreementProps {
  displayName: string
  country: ModulrCountriesType
}

export const ModulrAgreement = ({ displayName, country }: ModulrAgreementProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={16}>
      <Section flexCol gapY={4}>
        <InfoTitle flex gapX={4}>
          <p className="text-label text-foreground-prominent">{displayName}</p>
          <Tooltip
            bodyContent={
              <p className="text-body-regular-small text-inherit">
                {t(`modulrAgreement.descriptons.${country}.tooltip`)}
              </p>
            }
            type="complex"
          />
        </InfoTitle>
        <p className="text-body-regular text-foreground-subdued">
          {t(`modulrAgreement.descriptons.${country}.parapraph1`)}
        </p>
        <p className="text-body-regular text-foreground-subdued">
          {t(`modulrAgreement.descriptons.${country}.parapraph1`)}
        </p>
      </Section>
      <Section flexCol gapY={4}>
        <p className="text-label text-foreground-prominent">
          {t(`modulrAgreement.areFundsSafeguarded`)}
        </p>
        <p className="text-body-regular text-foreground-subdued">
          {t(`modulrAgreement.descriptons.${country}.parapraph2`)}
        </p>
      </Section>
    </Box>
  )
}
